import { IconBox, IconProps } from '@summer/jst-react-icon';

export const File = (props: Omit<IconProps, 'ref'>) => (
  <IconBox {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5 0H9V64H55V19.6009C55.0017 19.5674 55.0025 19.5338 55.0025 19.5C55.0025 19.4662 55.0017 19.4326 55 19.3991V18.6716L54.4751 18.1467C54.4371 18.1053 54.3973 18.0655 54.3559 18.0274L36.3293 0H35.5ZM33.5 4H13V60H51V21.5H33.5V4ZM48.1717 17.5H37.5V6.82774L48.1717 17.5Z"
    />
  </IconBox>
);
